(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glgs-tape-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const gcd = (a,b) => b ? gcd(b,a%b) : a;
  const R = (n,d=1n) => { const g=gcd(n<0n?-n:n,d); return [n/g,d/g]; };
  const add=(a,b)=>R(a[0]*b[1]+b[0]*a[1],a[1]*b[1]);
  const mul=(a,b)=>R(a[0]*b[0],a[1]*b[1]);
  const sub=(a,b)=>add(a,[-b[0],b[1]]);
  const floorDiv=(a,b)=>a[0]*b[1]/(a[1]*b[0]);
  const units={in:R(1n),ft:R(12n),yd:R(36n),mm:R(5n,127n),cm:R(50n,127n)};
  function dimension(value,unit,zero=false) {
    const s=String(value).trim();
    if (!units[unit] || !/^(?:\d{1,18}(?:\.\d{1,12})?|\.\d{1,12})$/.test(s)) throw Error('dimension');
    const [whole,part='']=s.split('.');
    const n=BigInt((whole||'0')+part);
    if (!zero && !n) throw Error('dimension');
    return mul(R(n,10n**BigInt(part.length)),units[unit]);
  }
  function plan(p,rotated=false) {
    if (!/^[1-9]\d{0,17}$/.test(String(p.quantity))) throw Error('quantity');
    const q=BigInt(p.quantity);
    let w=dimension(p.graphic_width,p.graphic_unit),h=dimension(p.graphic_height,p.graphic_unit);
    const a=mul(dimension(p.allowance,p.allowance_unit,true),R(2n));
    if(rotated) [w,h]=[h,w];
    w=add(w,a);h=add(h,a);
    const rw=dimension(p.roll_width,p.width_unit),rl=dimension(p.roll_length,p.length_unit);
    const lanes=floorDiv(rw,w), rows=floorDiv(rl,h),capacity=lanes*rows;
    const result={fits:capacity>0n,across:lanes,rows_per_roll:rows,complete_applications_per_roll:capacity,orientation_rotated:rotated,rolls_required:null,roll_groups:[]};
    if(!capacity)return result;
    const full=q/capacity,extra=q%capacity;
    for(const [count,n] of [[full,capacity],[extra?1n:0n,extra]]) {
      if(!count)continue;
      const consumed=mul(R((n+lanes-1n)/lanes),h);
      result.roll_groups.push({roll_count:count,applications_per_roll:n,consumed_length_in_per_roll:consumed,continuous_tail_length_in_per_roll:sub(rl,consumed),unused_area_within_consumed_length_sq_in:sub(mul(rw,consumed),mul(R(n),mul(w,h)))});
    }
    result.rolls_required=full+(extra?1n:0n);
    return result;
  }
  const exact=r=>r[1]===1n?String(r[0]):`${r[0]}/${r[1]}`;
  if(typeof module!=='undefined')module.exports={plan,dimension,exact};
  if(typeof window==='undefined')return;
  class TapeCalculator extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      this.form=this.querySelector('form');this.results=this.querySelector('[data-results]');this.status=this.querySelector('[data-status]');
      this.words=JSON.parse(this.querySelector('[data-words]').textContent);
      this.form.addEventListener('submit',e=>{e.preventDefault();this.calculate();});
      this.form.addEventListener('input',()=>this.clear());
      this.form.addEventListener('change',()=>this.clear());
      this.form.addEventListener('reset',()=>this.clear());
      this.querySelector('button[type=submit]').disabled=false;
    }
    clear(){this.results.replaceChildren();this.status.textContent='';this.form.querySelectorAll('[aria-invalid]').forEach(el=>{el.removeAttribute('aria-invalid');el.removeAttribute('aria-describedby');});}
    calculate(){
      this.clear();const p=Object.fromEntries(new FormData(this.form));
      for(const name of ['graphic_width','graphic_height','quantity','roll_width','roll_length','allowance']) {
        try {
          if(name==='quantity'){if(!/^[1-9]\d{0,17}$/.test(p[name]))throw Error();}
          else dimension(p[name],p[name.startsWith('graphic')?'graphic_unit':name==='roll_width'?'width_unit':name==='roll_length'?'length_unit':'allowance_unit'],name==='allowance');
        }catch(e){const el=this.form.elements[name];el.setAttribute('aria-invalid','true');el.setAttribute('aria-describedby',this.status.id);this.status.textContent=this.words.invalid;el.focus();return;}
      }
      for(const rotated of [false,true]) {
        const result=plan(p,rotated),card=document.createElement('article'),heading=document.createElement('h3');
        heading.textContent=rotated?this.words.rotated:this.words.original;card.append(heading);
        const line=(label,value)=>{const paragraph=document.createElement('p');paragraph.textContent=`${label}: ${value}`;card.append(paragraph);};
        if(!result.fits)line(this.words.fit,this.words.no_fit);
        else {
          line(this.words.rolls,result.rolls_required);line(this.words.capacity,result.complete_applications_per_roll);
          line(this.words.across,result.across);line(this.words.rows,result.rows_per_roll);
          for(const group of result.roll_groups){
            const h=document.createElement('h4');h.textContent=`${this.words.group}: ${group.roll_count} ${this.words.roll_label}`;card.append(h);
            line(this.words.applications,group.applications_per_roll);line(this.words.consumed,exact(group.consumed_length_in_per_roll));
            line(this.words.tail,exact(group.continuous_tail_length_in_per_roll));line(this.words.unused,exact(group.unused_area_within_consumed_length_sq_in));
          }
        }this.results.append(card);
      }
      this.status.textContent=this.words.updated;
    }
  }
  if(!customElements.get('glgs-tape-calculator'))customElements.define('glgs-tape-calculator',TapeCalculator);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
